module.exports = __webpack_public_path__ + "2e00dec06a0aa6c6b861b615002e3f48.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-78.cur
// module id = 477
// module chunks = 0